module.exports = "/images/marking-icon-measure.svg?739a07e0ae7bb1629337d6f2d31049bf";